import React, { useMemo } from "react";
import { parseISO } from "date-fns";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { AccountingReportFilters } from "@components/accounting/types";
import { GlDrilldownDrawer } from "@components/accounting/generalLedger/GlDrilldownDrawer";

interface Props {
    open: boolean;
    onClose: () => void;
    accountCodes: number[];
    startDate: string;
    endDate: string;
    entityId: number;
    ledgerId?: string;
    counterpartiesIds?: string[];
    withEmptyOrUnverifiedCounterparty?: boolean;
    ledgerBasis?: AccountingLedgerBasis;
}

export const PLTaskGLDrilldownDrawer: React.FC<Props> = ({
    open,
    onClose,
    accountCodes,
    startDate,
    endDate,
    entityId,
    ledgerId,
    counterpartiesIds,
    withEmptyOrUnverifiedCounterparty,
    ledgerBasis,
}) => {
    const filters = useMemo<AccountingReportFilters>(
        () => ({
            startDate: startDate ? parseISO(startDate) : undefined,
            endDate: endDate ? parseISO(endDate) : undefined,
            entityId,
            accountCodes: accountCodes.length > 0 ? accountCodes : undefined,
            counterpartiesIds:
                counterpartiesIds && counterpartiesIds.length > 0
                    ? counterpartiesIds
                    : undefined,
            withEmptyOrUnverifiedCounterparty,
            ledgerId,
        }),
        [
            startDate,
            endDate,
            entityId,
            accountCodes,
            counterpartiesIds,
            withEmptyOrUnverifiedCounterparty,
            ledgerId,
        ],
    );

    const entityIds = useMemo(() => [entityId], [entityId]);

    return (
        <GlDrilldownDrawer
            open={open}
            onClose={onClose}
            filters={filters}
            entityIds={entityIds}
            ledgerBasis={ledgerBasis}
        />
    );
};
